import apiClient from '../client';

export type ActivityFeedType = 'PAYMENT' | 'PAYMENT_REQUEST' | 'EXPENSE_REQUEST' | 'TASK' | 'CONTRACT';

export interface ActivityFeedItem {
  id: string;
  type: ActivityFeedType;
  title: string;
  description?: string;
  amount?: number;
  actorName?: string;
  occurredAt: string;
  projectId?: string;
  projectName?: string;
}

const activityFeedService = {
  getByProject: async (projectId: string, limit = 20) => {
    const response = await apiClient.get<ActivityFeedItem[]>(
      `/activity-feed/project/${projectId}?limit=${limit}`
    );
    return response.data;
  },
  getRecent: async (limit = 10) => {
    const response = await apiClient.get<ActivityFeedItem[]>(
      `/activity-feed/recent?limit=${limit}`
    );
    return response.data;
  },
};

export default activityFeedService;
